export const ActionType = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    FETCH_ALL: 'FETCH_ALL',
    FETCH_BY_SEARCH: 'FETCH_BY_SEARCH',
    LIKE: 'LIKE',
    FETCH_POST: 'FETCH_POST',
    COMMENT: 'COMMENT'
};

export const LoadingState = {
    START_LOADING: 'START_LOADING',
    END_LOADING: 'END_LOADING'
};

export const LoginActionType = {
    AUTH: 'AUTH',
    LOGOUT: 'LOGOUT'
}
